module.exports = __webpack_public_path__ + "img/remis-pin.832a0125.svg";